<template>
  <div>
    <div v-if="haveB === 'Y'" class="mt-5">
      <div class="container">
        <div class="body-button">
          <button v-for="button in serviceItems" :key="button.Name" :class="{ active: activeButton === button.Name }"
            style="color: black;" @click="goSeries(button)">{{ button.Name }}</button>
        </div>
      </div>


      <div class="row">
        <div v-if="listC.length > 0" v-for="(bodyItem, index) in listC" :key="index"
          class="col-12 col-md-6 row m-0 justify-content-center mt-5">
          <div class="card">
            <div class="img-container">
              <img :src="$Img.url + 'SPA/' + bodyItem.ItemPicPath"></img>

              <button class="reserve-btn" @click="goReserved(bodyItem)">預約<b-icon icon="triangle-fill"
                  rotate="90"></b-icon></button>


            </div>
            <div class="p-5" style="text-align: left;height: 70%;overflow: auto;">
              <div class="center" style="justify-content: space-between">
                <label class="spa-title">{{ bodyItem.Name }}</label>
                <div v-if="bodyItem.CanRsv == '1' && bodyItem.Duration != 0">
                  <div class="spa-content">{{ bodyItem.Duration }}min</div>
                </div>
              </div>
              <p class="spa-content mt-2">{{ bodyItem.Remark }}</p>
            </div>
            <div class="spa-price">NT${{ bodyItem.Pricing }}</div>
          </div>
        </div>
        <div class="footer-stack"></div>
      </div>
    </div>


    <div v-else>

      <div class="row">
        <div v-for="(serviceItem, index) in serviceItems" :key="index"
          class="col-12 col-md-6 row m-0 justify-content-center mt-5">
          <div class="card">
            <div class="img-container">
              <img :src="$Img.url + 'SPA/' + serviceItem.ItemPicPath"></img>
              <div v-if="serviceItem.CanRsv == '1'">
                <button class="reserve-btn" @click="goReserved(serviceItem)">預約<b-icon icon="triangle-fill"
                    rotate="90"></b-icon></button>
              </div>

            </div>

            <div class="p-5" style="text-align: left;height: 70%;overflow: auto;">
              <div class="center" style="justify-content: space-between">
                <label class="spa-title">{{ serviceItem.Name }}</label>
                <div v-if="serviceItem.CanRsv == '1' && serviceItem.Duration != 0">
                  <div class="spa-content">{{ serviceItem.Duration }}min</div>
                </div>
              </div>

              <p class="spa-content mt-2">{{ serviceItem.Remark }}</p>
            </div>
            <div v-if="serviceItem.CanRsv == '1'">
              <div class="spa-price">NT${{ serviceItem.Pricing }}</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="footer-stack"></div>
  </div>

</template>



<script>
export default {
  name: 'SpaItems',
  components: {},
  data() {
    return {
      serviceItems: [],
      haveB: "",
      listC: [],
      activeButton: null,
      IS_ON_FIRST_PAGE: false,
    };
  },
  async mounted() {
    this.SpaData = localStorage.getItem('Flowno');
    window.addEventListener("message", this.handleMessage);
    await this.init();
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log("Received message event:", event);
      console.log("Message data:", event.data);

      if (event.data === "backButtonClick") {
        if (this.IS_ON_FIRST_PAGE) {
          parent.postMessage("goToHome", "*");
        } else {
          // Vue Router 返回上一頁
          this.$router.back();
        }
      }
    },
    async init() {
      await this.GetSpaMenuB();
      await this.goSeries();
    },
    async GetSpaMenuB() {
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify({
            ShopNO: this.$Global.Base64Utils.atou(
              this.$cookieFunc.getCookie("ShopNO")
            ),
            //SuplNO: "20250103000001",
            Flowno: this.SpaData,
          })
        ),
      };

      this.$axios({
        method: "post",
        url: this.$URLJson.GetSpaMenuB,
        data: post_data,
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));

          this.serviceItems = data.ListB;
          this.haveB = data.HaveB;

          if (this.haveB === "Y" && this.serviceItems.length > 0 && this.serviceItems[0]) {
            const firstButton = this.serviceItems[0];
            this.activeButton = firstButton.Name;
            this.listC = firstButton.ListC || [];
          } else {
            this.listC = [];
          }


          console.log("ListB: ", this.serviceItems);
          console.log("ListC: ", this.listC);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async goSeries(button) {
      if (!button) return;
      this.activeButton = button.Name
      if (button && button.ListC) {
        this.listC = button.ListC;
      } else {
        this.listC = [];
      }
    },
    goReserved(item) {
      var SpaData = {
        Flowno: this.SpaData,
        SnB: item.SnB,
        SnC: item.SnC
      };
      localStorage.setItem('spa_data', JSON.stringify(SpaData));
      this.$router.push({ path: '/SpaCalendar' });
    }
  },
};
</script>

<style scoped>
.card {
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  height: 600px;
  width: 500px;
  cursor: pointer;
  border: none;
}

.spa-title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: bold;
}

.spa-content {
  font-size: 1.25rem;
  font-weight: bold;
}

.body-button {
  display: flex;
  justify-content: space-between;
  width: 100%;

  button {
    width: 150px;
    height: 80px;
    background-color: white;
    border-radius: 0.5rem;
    border: 1px solid orange;
    font-weight: bold;
  }

  button:hover,
  button.active {
    border: 3px solid orange;
  }
}

.container {
  width: 100%;
  margin: 0 auto;
}

.img-container {
  position: relative;
}

.reserve-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: #ec6c01;
  color: white;
  border: none;
  padding: 5px 10px;
  font-weight: bold;
  cursor: pointer;
  font-size: 1.75rem;
}

.spa-price {
  font-size: 1.75rem;
  color: #ec6c01;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Spa/SpaItems.vue